import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DemoMaterialModule } from '../../demo-material-module';
import { HomeComponent } from './home.component';
import { CtCardModule } from '@ctsolution/ct-framework';
import { CtWidgetModule } from '@ctsolution/ct-framework';

@NgModule({
  imports: [CommonModule, DemoMaterialModule, FlexLayoutModule, CtWidgetModule, CtCardModule],
  declarations: [HomeComponent],
  exports: [HomeComponent],
})
export class HomeModule {}
